// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"298":"ea1a75c2","299":"2c4d2dce","416":"4f223ee8"}[chunkId] + ".chunk.js";
};